import {
  useRouteMagicFlowDeepLink,
  type UseRouteMagicFlowDeepLinkArgs,
} from './use-route-magic-flow-deep-link';

/** Renders nothing; mount it only where a Magic Flow deep link can arrive. */
export const MagicFlowDeepLinkRouter = (props: UseRouteMagicFlowDeepLinkArgs) => {
  useRouteMagicFlowDeepLink(props);
  return null;
};
